var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"52","cy":"52","r":"15","stroke-width":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }